import { jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo } from "react";
import { DirectionEnum } from "@perxis-auto/shared";
import ConfigProvider from "antd/es/config-provider";
import styleInject from "style-inject";
import { ProviderContext } from "./context.js";
const DEFAULT_THEME = {
  hashed: true
};
const Provider = ({ children, theme, direction = DirectionEnum.Ltr, ...props }) => {
  const dynamicFontImport = useCallback(async () => {
    const { default: iconFontCss } = await import("../../assets/fonts/Perxis-Auto-Icons.scss.js");
    styleInject(iconFontCss, { insertAt: "top" });
  }, []);
  useEffect(() => {
    dynamicFontImport();
  }, [dynamicFontImport]);
  const contextValue = useMemo(() => ({ direction, theme, ...props }), [direction, theme, props]);
  return /* @__PURE__ */ jsx(ProviderContext.Provider, { value: contextValue, children: /* @__PURE__ */ jsx(
    ConfigProvider,
    {
      prefixCls: "ant-5_24_1",
      theme: { ...DEFAULT_THEME, ...theme },
      direction,
      ...props,
      children
    }
  ) });
};
export {
  Provider as default
};
//# sourceMappingURL=Provider.js.map
